import { vars } from "@common/styles";
import styled from "styled-components";

export const QuestionMark = styled.div`
  display: inline-flex !important;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;

  width: 3.2rem;
  height: 3.2rem;
  margin-left: 0.8rem;

  background-color: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey80};
  border-radius: 3.2rem;

  outline: none;
  cursor: help;
  transition: ${vars.transitions.hover};

  &:hover,
  &:focus-visible {
    border-color: ${vars.colors.grey70};
    background-color: ${vars.colors.grey90};
  }

  img {
    width: 2rem;
    height: 2rem;
  }
`;
